/* Speelt video's met class .lazy-autoplay pas af (en download ze dus pas)
   zodra ze bijna in beeld zijn; pauzeert buiten beeld. */
(function () {
	function playSafe(v) {
		var p = v.play();
		if (p && p.catch) { p.catch(function () {}); }
	}
	function init() {
		var videos = document.querySelectorAll('video.lazy-autoplay');
		if (!videos.length) return;
		videos.forEach(function (v) {
			v.muted = true;
			v.setAttribute('muted', '');
			v.playsInline = true;
		});
		if ('IntersectionObserver' in window) {
			var io = new IntersectionObserver(function (entries) {
				entries.forEach(function (e) {
					if (e.isIntersecting) { playSafe(e.target); }
					else { e.target.pause(); }
				});
			}, { threshold: 0.1, rootMargin: '200px 0px' });
			videos.forEach(function (v) { io.observe(v); });
		} else {
			videos.forEach(playSafe);
		}
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
